import "./PartnersLogin.module.css";
import Header from "@/reusable_sections/Header";
import LoginForm from "./sections/LoginForm";
import SecurityNotice from "./sections/SecurityNotice";
import Footer from "@/reusable_sections/Footer";
export default function PartnersLoginPage() {
  return <div>
      <Header />
      <LoginForm />
      <SecurityNotice />
      <Footer />
    </div>;
}